import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { buildQuantityString } from "../utils/orderDetailsUtils";
import { createKey } from "../../../../Shared/utils/createKey";
/**
 *
 * @param param0
 * @returns
 */
export const MealItems_Grid = ({ meal }) => {
    var _a;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
    return (_jsxs(Grid, Object.assign({ container: true, spacing: 1 }, { children: [_jsx(Grid, Object.assign({ item: true, xx: 1 }, { children: _jsx(Typography, { children: meal.mealQuantity }) })), _jsx(Grid, Object.assign({ item: true, xx: 11, sm: 3 }, { children: _jsx(Typography, { children: meal.mealType }) })), _jsx(Grid, Object.assign({ container: true, item: true, xx: 12, sm: 8 }, { children: (_a = meal === null || meal === void 0 ? void 0 : meal.recipes) === null || _a === void 0 ? void 0 : _a.map((recipe) => (_jsx(Grid, Object.assign({ item: true, xx: 12 }, { children: _jsx(Typography, { children: recipe.quantityString && !recipe.name
                            ? recipe.quantityString
                            : buildQuantityString(recipe.qty, recipe.name, meal.noMealsSelectedText) }) }), createKey()))) }))] })));
};
